/**
 * /eric/contact — Contact inbox for /not-sure submissions (T-051, PR-02).
 *
 * Route config only. Component lives in eric.contact.lazy.tsx (code-split).
 * No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/contact')({});
